export default __webpack_public_path__ + "static/media/clarity_notification-line-active.e0c31b0c.svg";